"use client";

import { MainLink, SecondaryLink, TitleH2 } from "@/components/shared/public";
import { Link } from "@/i18n/navigation";
import { useTranslations } from "next-intl";
import {
  adTech,
  fashionStore,
  hoodHouseHH,
  house,
  lightTower,
  oneRoom,
  twoRoom,
} from "../../../../public/images/three-sixty";
import ExampleCard from "./ExampleCard";

const Examples = () => {
  const t = useTranslations("threeSixtyExamples");
  const tC = useTranslations("common");

  const examples = [
    {
      title: t("examples.title"),
      description: "Hood House Hamburg",
      src: hoodHouseHH,
      url: "https://tour.gs360.de/b40661b1-145a-4109-a2f7-38724c50a071/",
    },
    {
      title: t("examples.title"),
      description: t("examples.one"),
      src: adTech,
      url: "https://tour.gs360.de/b53f0f93-6022-406e-9991-855424ce350c/",
    },
    {
      title: t("examples.title"),
      description: t("examples.two"),
      src: fashionStore,
      url: "https://tour.gs360.de/2d849b03-bca4-4a16-8513-f908ef36cdaa/",
    },
    {
      title: t("examples.title"),
      description: t("examples.three"),
      src: oneRoom,
      url: "https://tour.gs360.de/543bb0b0-0122-4e75-9379-c53792761a27/",
    },
    {
      title: t("examples.title"),
      description: t("examples.four"),
      src: house,
      url: "https://tour.gs360.de/ccc81e44-7c50-44fd-9ffc-db664e8e051c/",
    },
    {
      title: t("examples.title"),
      description: t("examples.five"),
      src: lightTower,
      url: "https://tour.gs360.de/c7c011d5-d327-45d8-88af-515d15113eb0/",
    },
    {
      title: t("examples.title"),
      description: t("examples.six"),
      src: twoRoom,
      url: "https://tour.gs360.de/a2688098-40a4-457d-a6be-eb453d5093c3/",
    },
  ];

  return (
    <div className="gs--page-column py-16">
      <div className="flex flex-col gap-20">
        <div className="flex flex-col gap-6">
          <TitleH2 title={t("title")} />
          <div className="text-ring flex flex-col gap-3">
            <p>{t("description")}</p>

            <span className="font-semibold">
              {t("topic.title")}{" "}
              <span className="font-normal">{t("topic.description")}</span>{" "}
            </span>
            <span className="font-semibold">
              {t("topic1.title")}{" "}
              <span className="font-normal">
                {t("topic1.description")}
              </span>{" "}
            </span>
            <span className="font-semibold">
              {t("topic2.title")}{" "}
              <span className="font-normal">
                {t("topic2.description")}
              </span>{" "}
            </span>
            <span className="font-semibold">
              {t("topic3.title")}{" "}
              <span className="font-normal">
                {t("topic3.description")}
              </span>{" "}
            </span>
          </div>
        </div>

        <div className="flex flex-wrap justify-center gap-10">
          {examples.map((exp, i) => {
            return (
              <Link
                key={i}
                href={exp.url}
                target="_blank"
                rel="noopener noreferrer"
              >
                <ExampleCard
                  title={exp.title}
                  description={exp.description}
                  src={exp.src}
                  alt={`360-Grad-Rundgang Beispiel: ${exp.description}`}
                />
              </Link>
            );
          })}
        </div>
        <div className="flex flex-col-reverse gap-5 sm:flex-row">
          <SecondaryLink href={"/360-grad-rundgang"} title={tC("back")} />
          <MainLink href={"/login"} title={tC("nowOrder")} />
        </div>
      </div>
    </div>
  );
};

export default Examples;
